import React, { useContext } from "react";
import { NativeSelect } from "@altimateai/lego";
import { INSIGHT_SORT_OPTIONS } from "../constants";
import { useInsightState } from "../context";
import { InsightContext } from "../context/InsightContextProvider";
import { setSort } from "../context/insightSlice";

interface InsightSortDropdownProps {}

export const InsightSortDropdown: React.FC<InsightSortDropdownProps> = () => {
  const {
    sort: { selectedOption },
  } = useInsightState();
  const { dispatch } = useContext(InsightContext);

  const handleSortChange = (value: string) => {
    const option = INSIGHT_SORT_OPTIONS.find(opt => opt.label === value);
    if (option) {
      dispatch(
        setSort({
          sortBy: option.value,
          sortOrder: option.order as "asc" | "desc",
          selectedOption: value,
        })
      );
    }
  };

  return (
    <NativeSelect
      options={INSIGHT_SORT_OPTIONS.map(opt => ({ label: opt.label, value: opt.label }))}
      value={selectedOption}
      onChange={handleSortChange}
      placeholder="Sort by"
      className="al-max-w-[200px]"
      size={"sm"}
      variant={"outline"}
    />
  );
};
